import React from "react";
import css from "../css/welcomePage.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGithub,
  faTwitter,
  faCodepen,
  faDribbble,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";

import { faEnvelope, faGlobe } from "@fortawesome/free-solid-svg-icons";

function WelcomePage() {
  function codepenClick() {
    window.open("https://codepen.com", "_blank");
  }

  function githubClick() {
    window.open("https://github.com/JonathanElias1", "_blank");
  }

  function twitterClick() {
    window.open("https://twitter.com/joncodeguy", "_blank");
  }

  function emailClick() {
    window.open("mailto:jon-e-worldwide@jon-e.org", "_blank");
  }

  // function dribbbleClick() {
  //   window.open("https://dribbble.com", "_blank");
  // }

  function siteClick() {
    window.open("https://jon-e.com", "_blank");
  }

  function linkedinClick() {
    window.open("https://www.linkedin.com/in/jonathanelias1/", "_blank");
  }

  //make this turn cursor into a pointer when hovering over something eventually
  function mouseOver() {
    console.log(`test`);
  }

  return (
    <div className="welcomePage">
      {/* Star background */}
      <div id="stars"></div>
      <div id="stars2"></div>
      <div id="stars3"></div>

      {/* Text */}
      <h1 className="welcome-text">Welcome to CSS</h1>
      <p>
        In this site I will attempt to teach you CSS through the usage of
        flowcharts and user interactivity. <br />
        <br />
        All nodes are draggable within the flowcharts, and users can utilize
        Codepens to see source code for almost every CSS topic. <br />
        <br />I recommend learning from left to right in topics within the
        header and doing the same within each page when applicable. <br />
        <br />
        If you are feeling a bit lost in terms of navigating the site I included
        a video below for reference.
      </p>

      {/* Video */}
      <div className="video-centered">
        <div className="video2-responsive">
          <iframe
            src={`https://www.youtube.com/embed/0GM7gkT61ko`}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="Embedded youtube"
          />
        </div>
      </div>
      <p>
        If you have any questions or feel like I should add something to this
        webpage or make something more clear please don't hesitate to reach out.
        <br />
        My contact information is below.
      </p>
      {/* Footer burger menu */}
      <div className="footer-menu-container">
        <div id="ribbon">
          <h3 className="white">Contact me:</h3>
          <div className="footer" id="footer">
            <h2>Contact me:</h2>
            <div>
              <a
                className="footer__link"
                onClick={emailClick}
                onMouseOver={mouseOver}
              >
                jonathanelias3223@gmail.com
                {/* <FontAwesomeIcon icon={faEnvelope}></FontAwesomeIcon>{" "} */}
              </a>
            </div>

            <ul className="social-list">
              <li className="social-list__item">
                <a className="social-list__link" onClick={linkedinClick}>
                  <FontAwesomeIcon icon={faLinkedin}></FontAwesomeIcon>{" "}
                </a>
              </li>

              <li className="social-list__item">
                <a className="social-list__link" onClick={githubClick}>
                  <FontAwesomeIcon icon={faGithub}></FontAwesomeIcon>
                </a>
              </li>

              <li className="social-list__item">
                <a className="social-list__link" onClick={codepenClick}>
                  <FontAwesomeIcon icon={faCodepen}></FontAwesomeIcon>{" "}
                </a>
              </li>

              <li className="social-list__item">
                <a className="social-list__link" onClick={twitterClick}>
                  <FontAwesomeIcon icon={faTwitter}></FontAwesomeIcon>
                </a>
              </li>

              {/* <li className="social-list__item">
                <a className="social-list__link" onClick={dribbbleClick}>
                  <FontAwesomeIcon icon={faDribbble}></FontAwesomeIcon>{" "}
                </a>
              </li> */}

              <li className="social-list__item">
                <a className="social-list__link" onClick={siteClick}>
                  <FontAwesomeIcon icon={faGlobe}></FontAwesomeIcon>{" "}
                </a>
              </li>

              {/* //listed items end */}
            </ul>
          </div>
        </div>
      </div>

      {/* End of footer burger menu */}
      {/* Footer */}
      <div className="footer-wrapper">
        <div className="footer" id="footer">
          <h3 className="white" id="white">
            Contact me:
          </h3>
          <div>
            <a
              className="footer__link"
              onClick={emailClick}
              onMouseOver={mouseOver}
            >
              jon-e-worldwide@jon-e.org
              {/* <FontAwesomeIcon icon={faEnvelope}></FontAwesomeIcon>{" "} */}
            </a>
          </div>
          <div className="footer-not-burger-list">
            <ul className="social-list">
              <li className="social-list__item">
                <a className="social-list__link" onClick={linkedinClick}>
                  <FontAwesomeIcon icon={faLinkedin}></FontAwesomeIcon>{" "}
                </a>
              </li>

              <li className="social-list__item">
                <a className="social-list__link" onClick={githubClick}>
                  <FontAwesomeIcon icon={faGithub}></FontAwesomeIcon>
                </a>
              </li>

              <li className="social-list__item">
                <a className="social-list__link" onClick={codepenClick}>
                  <FontAwesomeIcon icon={faCodepen}></FontAwesomeIcon>{" "}
                </a>
              </li>

              <li className="social-list__item">
                <a className="social-list__link" onClick={twitterClick}>
                  <FontAwesomeIcon icon={faTwitter}></FontAwesomeIcon>
                </a>
              </li>

              {/* <li className="social-list__item">
                <a className="social-list__link" onClick={dribbbleClick}>
                  <FontAwesomeIcon icon={faDribbble}></FontAwesomeIcon>{" "}
                </a>
              </li> */}

              <li className="social-list__item">
                <a className="social-list__link" onClick={siteClick}>
                  <FontAwesomeIcon icon={faGlobe}></FontAwesomeIcon>{" "}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WelcomePage;
